exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".support-box-item[data-v-474156f6]{padding:41px 32px 20px}.support-item[data-v-474156f6]{width:25%;padding:27px 0 30px;margin-right:-1px;text-align:center;border-top:1px solid #eee;border-right:1px solid #eee}.support-item[data-v-474156f6]:nth-child(4n){border-right:none;margin-right:0}.support-item[data-v-474156f6]:nth-child(-n+4){border-top:none}.support-item[data-v-474156f6]:hover{box-shadow:0 2px 10px 2px rgba(0,0,0,.1)}.support-item:hover .support-name[data-v-474156f6]{color:#f16622}.support-item .support-img[data-v-474156f6]{width:76px;height:65px;vertical-align:top}.support-item .support-name[data-v-474156f6]{margin-top:20px;color:#393939;font-size:16px;font-weight:700}.support-item .support-desc[data-v-474156f6]{margin-top:21px;color:#7c7c7c;font-size:12px;line-height:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-474156f6","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/index/support.vue
// module id = 731
// module chunks = 0